const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Content Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Overview the resource defined to get Overview queries
 */
app.controller('overviewContentController', ['Application', 'Authorization', 'Analyze', 'Overview', 'AccessHelper', '$location', '$translate', function (Application, Authorization, Analyze, Overview, AccessHelper, $location, $translate) {
    var self = this;
    self.engage = (Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage) || false;
    self.features = Application.features.flags();
    self.imported_content =  self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass || false;
    self.contentCurrentTab = 'mycontent';

    self.tabAccessed = {};

    self.changeTab = function(tab) {
      self.tabAccessed[tab] = true;
      self.contentCurrentTab = tab;
    };

    self.tabAccess = {
      pendingApproval: AccessHelper.isAllowed(['admin', 'content', 'approve_content'], null, ['admin', 'creator']),
      content: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
        ['admin', 'content', 'all_edit'],
        ['admin', 'content', 'all_analytics'],
        ['admin', 'content', 'articles_create'],
        ['admin', 'content', 'articles_edit'],
        ['admin', 'content', 'articles_analytics'],
        ['admin', 'content', 'files_create'],
        ['admin', 'content', 'files_edit'],
        ['admin', 'content', 'files_analytics'],
        ['admin', 'content', 'videos_create'],
        ['admin', 'content', 'videos_edit'],
        ['admin', 'content', 'videos_analytics']
      ], ['admin', 'creator', 'collaborator']),
      tracks: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
        ['admin', 'content', 'all_edit'],
        ['admin', 'content', 'tracks_create'],
        ['admin', 'content', 'tracks_edit'],
        ['admin', 'content', 'all_analytics'],
        ['admin', 'content', 'tracks_analytics']
      ], ['admin', 'creator', 'collaborator']),
      scorm: self.features.scorm && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
        ['admin', 'content', 'all_edit'],
        ['admin', 'content', 'scorm_create'],
        ['admin', 'content', 'scorm_edit'],
        ['admin', 'content', 'all_analytics'],
        ['admin', 'content', 'scorm_analytics']
      ], ['admin', 'creator', 'collaborator']),
      thirdParty: self.imported_content && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
        ['admin', 'content', 'all_edit'],
        ['admin', 'content', 'imported_content_create'],
        ['admin', 'content', 'imported_content_edit'],
        ['admin', 'content', 'all_analytics'],
        ['admin', 'content', 'imported_canalyticsnt_edit']
      ], ['admin', 'creator', 'collaborator']),
      presentations: self.features.presentations && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
        ['admin', 'content', 'all_edit'],
        ['admin', 'content', 'presentations_create'],
        ['admin', 'content', 'presentations_edit'],
        ['admin', 'content', 'all_analytics'],
        ['admin', 'content', 'presentations_analytics']
      ], ['admin', 'creator', 'collaborator']),
      archived: AccessHelper.isAllowed(['admin', 'content', 'unarchive_content'], null, ['admin', 'creator']),
      myContent: true
    };

    if (!self.tabAccess.pendingApproval && !self.tabAccess.content && !self.tabAccess.tracks && !self.tabAccess.scorm && !self.tabAccess.thirdParty && !self.tabAccess.presentations) {
      if (!self.tabAccess.archived) {
        Application.navigation.goTo('/overview/workshops');
        return;
      }
       self.tabAccess.myContent = false;
      self.contentCurrentTab = 'archived';
    }

    self.translations = {};

    self.contentOptions = {};
    self.information = {
      totalContent: 0,
      totalTracks: 0,
      likesLastMonth: 0,
      sharesLastMonth: 0
    };

    if ($location.hash()) {
      self.hash = $location.hash();
    }
    self.isCollaborator = function() {
      return Authorization.isCollaborator();
    };

    self.initialize = function () {

      //get number of total content items
      Overview.totals({subresource: "content", users: "all"}, function (data) {
        self.information.totalContent = data['total_content'] ? data['total_content'] : 0;
      }, function (error) {
        console.log('Error getting overview totals:', error);
      });

      //get number of total learning tracks
      Overview.totals({subresource: "tracks", users: "all"}, function (data) {
        self.information.totalTracks = data['total_tracks'] ? data['total_tracks'] : 0;
      }, function (error) {
        console.log('Error getting overview totals:', error);
      });

      //get likes of past 30 days
      Analyze.totals({subresource: "likes", users: "all"}, function (data) {
        self.information.likesLastMonth = data['total_likes'] - data['total_likes_up_to_last_month'];
      }, function (error) {
        console.log('Error getting totals:', error);
      });

      //get shares of past 30 days
      Analyze.totals({subresource: "shares", users: "all"}, function (data) {
        self.information.sharesLastMonth = data['total_shares'] - data['total_shares_up_to_last_month'];
      }, function (error) {
        console.log('Error getting totals:', error);
      });

    };

    self.initialize();

    $translate([
      'overviewContent.content_items',
      'overviewContent.added_in_total',
      'overviewContent.learning_tracks',
      'overviewContent.added_in_total',
      'overviewContent.likes',
      'overviewContent.past_30_days',
      'overviewContent.shares',
      'overviewContent.past_30_days'
    ]).then(function (translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);
  